<template>
    <Transition>
        <div class="w-100 h-100 d-flex justify-content-center align-items-center pre-loader bg-dark flex-column" v-if="visible" >
            <div class="loader"></div>
            <p class="m-0 mt-4 text-light fs-4">{{ text }}</p>
        </div>
    </Transition>
</template>

<script lang="ts">
import globalModule from '@/store/modules/global.module';
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ReportLoader extends Vue {
    get visible() {
        return globalModule.reportLoader.visible
    }

    get text() {
        return globalModule.reportLoader.text
    }
}
</script>

<style lang="css" scoped>
    /* HTML: <div class="loader"></div> */
    .loader {
    width: 40px;
    aspect-ratio: 1;
    position: relative;
    transform: rotate(45deg);
    }
    .loader:before,
    .loader:after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50% 50% 0 50%;
    background: #dc3545;
    mask: radial-gradient(circle 10px at 50% 50%,#0000 94%,#212529);
    }
    .loader:after {
    animation: l6 1s infinite;
    transform: perspective(300px) translateZ(0px)
    }
    @keyframes l6 {
    to {transform: perspective(300px) translateZ(150px);opacity:0}
    }
</style>
